import React from "react";

export function OrderRowCell({ children }: { children: React.ReactNode }) {
  return <td className="tw-text-grey-300">{children}</td>;
}
